import { render } from "./FormPositionTrainingTable.vue?vue&type=template&id=348c8074&scoped=true&ts=true"
import script from "./FormPositionTrainingTable.vue?vue&type=script&lang=ts"
export * from "./FormPositionTrainingTable.vue?vue&type=script&lang=ts"

import "./FormPositionTrainingTable.vue?vue&type=style&index=0&id=348c8074&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348c8074"]])

export default __exports__